import { CARRIER_NAME, ClaimOutcome } from './claimsData'

/** What the customer actually wants to know: did money move, and how much. */
export function OutcomeCard({ outcome }: { outcome: ClaimOutcome }) {
  if (outcome === ClaimOutcome.PAID) {
    return (
      <dl className="border-ink-200 bg-surface mt-2.5 flex flex-wrap gap-x-6 gap-y-2 rounded-sm border p-3.5">
        <div>
          <dt className="text-ink-400 font-mono text-[10px] tracking-[0.12em] uppercase">Paid loss</dt>
          <dd className="mt-0.5 text-sm font-semibold">$18,400.00</dd>
        </div>
        <div>
          <dt className="text-ink-400 font-mono text-[10px] tracking-[0.12em] uppercase">Your deductible</dt>
          <dd className="mt-0.5 text-sm font-semibold">$2,500.00</dd>
        </div>
        <div>
          <dt className="text-ink-400 font-mono text-[10px] tracking-[0.12em] uppercase">Paid to</dt>
          <dd className="mt-0.5 text-sm font-semibold">Elite Commodity Express</dd>
        </div>
      </dl>
    )
  }

  if (outcome === ClaimOutcome.DENIED) {
    return (
      <div className="border-ink-200 bg-surface mt-2.5 rounded-sm border p-3.5">
        <p className="text-ink-500 text-sm">
          {CARRIER_NAME} declined this claim. Your broker can tell you why and what it would take to appeal.
        </p>
      </div>
    )
  }

  return (
    <div className="border-ink-200 bg-surface mt-2.5 rounded-sm border p-3.5">
      <p className="text-ink-500 text-sm">
        The repair came in under your $2,500 deductible, so no payment was made and the claim was closed.
      </p>
    </div>
  )
}
